import { useEffect, useRef, useState } from "react";
import { clientName } from "../utils";

export const normText = (s) => (s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

const norm = normText;

export default function ClientCombobox({ clients, value, onChange, testid }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const ref = useRef(null);
  const selected = clients.find((c) => c.id === value);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const filtered = clients.filter((c) => norm(clientName(c)).includes(norm(text)));

  return (
    <div ref={ref} className="relative">
      <input
        data-testid={testid}
        type="text"
        autoComplete="off"
        value={open ? text : (selected ? clientName(selected) : "")}
        placeholder="Tous les clients"
        onFocus={() => { setText(""); setOpen(true); }}
        onChange={(e) => { setText(e.target.value); setOpen(true); }}
        className="block rounded-lg border border-slate-300 px-3 py-1.5 text-sm bg-white w-56 focus:ring-2 focus:ring-slate-900 focus:outline-none"
      />
      {open && (
        <div className="absolute z-30 mt-1 w-64 max-h-56 overflow-y-auto bg-white border border-slate-200 rounded-lg shadow-lg" data-testid={`${testid}-dropdown`}>
          <button type="button" data-testid={`${testid}-all`} onClick={() => { onChange(""); setOpen(false); }}
            className="w-full text-left px-3 py-2 text-sm font-semibold text-slate-500 hover:bg-slate-100">
            Tous les clients
          </button>
          {filtered.map((c) => (
            <button type="button" key={c.id} data-testid={`${testid}-option-${c.id}`}
              onClick={() => { onChange(c.id); setOpen(false); }}
              className={`w-full text-left px-3 py-2 text-sm hover:bg-slate-100 ${c.id === value ? "font-semibold text-slate-900" : "text-slate-700"}`}>
              {clientName(c)}
            </button>
          ))}
          {filtered.length === 0 && <div className="px-3 py-2 text-xs text-slate-400">Aucun client ne correspond</div>}
        </div>
      )}
    </div>
  );
}
